import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService, UserService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CostProfileService } from '../cost-profile.service';
import { CostProfile } from '../cost-profile';
import { CostProfileComponent } from '../cost-profile/cost-profile.component';

@Component({
    selector: 'app-cost-profile-list',
    templateUrl: './cost-profile-list.component.html',
    styleUrls: ['./cost-profile-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CostProfileListComponent implements OnInit {
    payWhenStatuses: any;
    payStatuses: any;
    users: any;
	constructor(
		private userService: UserService,
		private costProfileService: CostProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.payWhenStatuses = costProfileService.payWhenStatuses;
		this.payStatuses = costProfileService.payStatuses;
	}



	// data
	costProfiles: any;
	costProfile: CostProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	columns: any[] = [
		{ field: 'costProfileId', header: 'Id', width: 'auto' },
		{ field: 'shortTermRentalId', header: 'ShortTermRentalId', width: 'auto' },
		{ field: 'propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'payTo', header: 'Pay To', width: 'auto' },
		{ field: 'payToUserId', header: 'Pay To UserId', width: 'auto' },
		{ field: 'payWhen', header: 'Pay When', width: 'auto' },
		{ field: 'payStatus', header: 'Pay Status', width: 'auto' },
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'quantity', header: 'Quantity', width: 'auto' },
		{ field: 'costAmount', header: 'Cost Amount', width: 'auto' },
		{ field: 'costPercent', header: 'Cost Percent', width: 'auto' },
	];
	
	ngOnInit(): void {
		this.fetchUsers();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.costProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-costProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.costProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.costProfiles = res.data.costProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.costProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(costProfile: CostProfile) {
		try {
			this.formLoading = true;
			this.costProfileService.update(costProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.costProfiles.map((costProfile, i) => {
							if (costProfile.costProfileId === res.data.costProfile.costProfileId) {
								this.costProfiles[i] = res.data.costProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(costProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(costProfile));

			this.formLoading = true;
			this.costProfileService.delete(costProfile.costProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.costProfiles.splice(this.costProfiles.indexOf(costProfile), 1);
						this.recordTotal = this.costProfiles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'CostProfile ' + costProfile.costProfileId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'CostProfile ' + costProfile.costProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Cost Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CostProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addCostProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(costProfile: CostProfile) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			costProfile: costProfile,
			title: 'Edit Cost Profile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(CostProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateCostProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteCostProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addCostProfileCB(costProfile: CostProfile) {
		console.log('Adding CostProfile: ' + JSON.stringify(costProfile));
		// if we don't have a costProfiles array yet...
		if (!this.costProfiles) {
			this.costProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.costProfiles.unshift(costProfile);

		// no idea what this is but it is required to update the array
		this.costProfiles = [...this.costProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CostProfile ' + costProfile.costProfileId + ' Added', life: 3000 });
	}

	updateCostProfileCB(costProfile: CostProfile) {
		console.log('Updating CostProfile: ' + JSON.stringify(costProfile));
		let itemIndex = this.costProfiles.findIndex((item: any) => item.costProfileId === costProfile.costProfileId);
		this.costProfiles[itemIndex] = costProfile;

		// no idea what this is but it is required to update the array
		this.costProfiles = [...this.costProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CostProfile ' + costProfile.costProfileId + ' Updated', life: 3000 });
	}

	deleteCostProfileCB(costProfile: CostProfile) {
		console.log('Removing CostProfile: ' + costProfile);
		this.costProfiles.splice(this.costProfiles.indexOf(costProfile), 1);
		this.recordTotal = this.costProfiles.length;

		// no idea what this is but it is required to update the array
		this.costProfiles = [...this.costProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'CostProfile ' + costProfile.costProfileId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.costProfiles ? this.first === (this.costProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.costProfiles ? this.first === 0 : true; }

	get Statuses() {
		return this.payWhenStatuses;
	}

	getPayWhenName(costProfile: any) {
		if (costProfile?.payWhen) {
			const status = this.payWhenStatuses.find((e: any) => e.value == costProfile.payWhen);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getPayStatusName(costProfile: any) {
		if (costProfile?.payStatus) {
			const status = this.payStatuses.find((e: any) => e.value == costProfile.payStatus);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getUserName(costProfile: any) {
		if (costProfile?.payToUserId) {
			const status = this.users.find((e: any) => e.userId == costProfile.payToUserId);
			return status.lastName;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	fetchUsers() {
		if (!this.users || this.users === undefined || this.users.length < 1) {
			try {
				this.userService.findAll()
					.subscribe(
						res => {
							console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.users = res.data.users;
							return this.users;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.users);
		}
	}
}
